import Address from '../../../smoothr-web-app-core/models/Address';

export class AddressUtils {
	static validateAddress(address: Address): boolean {
		return !!(address.street && address.postalCode && address.city);
	}

	static formatAddress(address: Address): string {
		if (!address) return '';
		return `${address.street} ${address.number || ''}, ${address.postalCode} ${address.city}`;
	}

	static parseAddressString(addressString: string): Address {
		const address: Address = new Address();

		// Simple German/European zip code extraction (5 digits)
		const zipMatch = addressString.match(/\b\d{5}\b/);
		if (zipMatch) {
			address.postalCode = zipMatch[0];
		}

		// Attempt to split by comma for City
		const parts = addressString.split(',');
		if (parts.length > 1) {
			// Assume last part is city if it has no numbers, or first part is street
			// This is very heuristic
			const possibleCity = parts[parts.length - 1].trim();
			const possibleZipAndCity = parts[parts.length - 1].trim().match(/(\d{5})\s+(.+)/);

			if (possibleZipAndCity) {
				address.postalCode = possibleZipAndCity[1];
				address.city = possibleZipAndCity[2];
			} else {
				address.city = possibleCity;
			}

			address.street = parts[0].trim();
		} else {
			// Fallback: whole string is street (user might need to elaborate)
			address.street = addressString;
		}

		// Improve street/number parsing if street contains number at end
		if (address.street) {
			const streetMatch = address.street.match(/(.+?)\s+(\d+[a-zA-Z]?)$/);
			if (streetMatch) {
				address.street = streetMatch[1].trim();
				address.number = streetMatch[2];
			}
		}

		return address;
	}
}
